import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../_theme/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_nuxtdomainconfig8f687592_07014b26 from 'nuxt_plugin_nuxtdomainconfig8f687592_07014b26' // Source: ./nuxt.domainconfig.8f687592.js (mode: 'all')
import nuxt_plugin_nuxtdefaultlocale0c0e12f6_0836470d from 'nuxt_plugin_nuxtdefaultlocale0c0e12f6_0836470d' // Source: ./nuxt.defaultlocale.0c0e12f6.js (mode: 'all')
import nuxt_plugin_plugin_573e30f8 from 'nuxt_plugin_plugin_573e30f8' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_50c80fe0 from 'nuxt_plugin_plugin_50c80fe0' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_deviceplugin_77248cce from 'nuxt_plugin_deviceplugin_77248cce' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_214bd3b6 from 'nuxt_plugin_cookieuniversalnuxt_214bd3b6' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_image_3fa1e5ee from 'nuxt_plugin_image_3fa1e5ee' // Source: ./image.js (mode: 'all')
import nuxt_plugin_pluginutils_11babbed from 'nuxt_plugin_pluginutils_11babbed' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_43fc01f8 from 'nuxt_plugin_pluginrouting_43fc01f8' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7b04ec77 from 'nuxt_plugin_pluginmain_7b04ec77' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_workbox_65968cac from 'nuxt_plugin_workbox_65968cac' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_nuxtpluginc462872c_014eb79d from 'nuxt_plugin_nuxtpluginc462872c_014eb79d' // Source: ./nuxt.plugin.c462872c.js (mode: 'all')
import nuxt_plugin_pluginse2etesting38f658eb_48fd4454 from 'nuxt_plugin_pluginse2etesting38f658eb_48fd4454' // Source: ./plugins.e2e-testing.38f658eb.js (mode: 'all')
import nuxt_plugin_pluginslogger6bab7958_0887f0e2 from 'nuxt_plugin_pluginslogger6bab7958_0887f0e2' // Source: ./plugins.logger.6bab7958.js (mode: 'all')
import nuxt_plugin_pluginsssr2cb5d954_5f78cae8 from 'nuxt_plugin_pluginsssr2cb5d954_5f78cae8' // Source: ./plugins.ssr.2cb5d954.js (mode: 'all')
import nuxt_plugin_pluginscontext0b091dd2_21717fe1 from 'nuxt_plugin_pluginscontext0b091dd2_21717fe1' // Source: ./plugins.context.0b091dd2.js (mode: 'all')
import nuxt_plugin_affixbannerclient_7d0b875d from 'nuxt_plugin_affixbannerclient_7d0b875d' // Source: ../plugins/affix-banner.client.js (mode: 'client')
import nuxt_plugin_vClickOutsideclient_fa2ecf0a from 'nuxt_plugin_vClickOutsideclient_fa2ecf0a' // Source: ../plugins/vClickOutside.client.js (mode: 'client')
import nuxt_plugin_linkhandler_beb21142 from 'nuxt_plugin_linkhandler_beb21142' // Source: ../plugins/linkhandler.client (mode: 'client')
import nuxt_plugin_veevalidate_1a0c1998 from 'nuxt_plugin_veevalidate_1a0c1998' // Source: ../plugins/vee-validate.js (mode: 'all')
import nuxt_plugin_datadogclient_20227ffa from 'nuxt_plugin_datadogclient_20227ffa' // Source: ../plugins/datadog.client.js (mode: 'client')
import nuxt_plugin_bloomreachtrackingclient_6dd71088 from 'nuxt_plugin_bloomreachtrackingclient_6dd71088' // Source: ../plugins/bloomreach-tracking.client.js (mode: 'client')
import nuxt_plugin_trustedshopsclient_40deca0c from 'nuxt_plugin_trustedshopsclient_40deca0c' // Source: ../plugins/trustedshops.client.js (mode: 'client')
import nuxt_plugin_promptwatchclient_4df5cc53 from 'nuxt_plugin_promptwatchclient_4df5cc53' // Source: ../plugins/promptwatch.client.js (mode: 'client')
import nuxt_plugin_overrideI18nsetLocale_c41bb4ca from 'nuxt_plugin_overrideI18nsetLocale_c41bb4ca' // Source: ../plugins/overrideI18nsetLocale.js (mode: 'all')
import nuxt_plugin_paypalsdkclient_a888a698 from 'nuxt_plugin_paypalsdkclient_a888a698' // Source: ../plugins/paypal-sdk.client.js (mode: 'client')
import nuxt_plugin_googlePublisherTags_08b8f4f1 from 'nuxt_plugin_googlePublisherTags_08b8f4f1' // Source: ../plugins/googlePublisherTags.js (mode: 'client')
import nuxt_plugin_etrustedclient_56d2ae46 from 'nuxt_plugin_etrustedclient_56d2ae46' // Source: ../plugins/etrusted.client.js (mode: 'client')
import nuxt_plugin_algolialoggerserver_1f245e9e from 'nuxt_plugin_algolialoggerserver_1f245e9e' // Source: ../plugins/algolia-logger.server.ts (mode: 'server')
import nuxt_plugin_meta_5f3262f2 from 'nuxt_plugin_meta_5f3262f2' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: function() {
    const metaTags = [
    { charset: 'utf-8' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    {
      hid: 'description',
      name: 'description',
      content: process.env.npm_package_description || '' },

    ...this.$nuxtI18nHead({ addSeoAttributes: true }).meta];

    if (this.$config.shouldBlockIndexing) {
      metaTags.push({
        name: 'robots',
        content: 'noindex' });
    }

    return {
      title: this.$config.domainConfig.websiteLabel,
      meta: metaTags,
      link: [
      {
        rel: 'icon',
        type: 'image/x-icon',
        href: this.$config.domainConfig.favicon }],

      script: [
      {
        src: '/_nuxt/init-gtm.js' }] };
  },

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_nuxtdomainconfig8f687592_07014b26 === 'function') {
    await nuxt_plugin_nuxtdomainconfig8f687592_07014b26(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtdefaultlocale0c0e12f6_0836470d === 'function') {
    await nuxt_plugin_nuxtdefaultlocale0c0e12f6_0836470d(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_573e30f8 === 'function') {
    await nuxt_plugin_plugin_573e30f8(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_50c80fe0 === 'function') {
    await nuxt_plugin_plugin_50c80fe0(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_77248cce === 'function') {
    await nuxt_plugin_deviceplugin_77248cce(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_214bd3b6 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_214bd3b6(app.context, inject)
  }

  if (typeof nuxt_plugin_image_3fa1e5ee === 'function') {
    await nuxt_plugin_image_3fa1e5ee(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_11babbed === 'function') {
    await nuxt_plugin_pluginutils_11babbed(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_43fc01f8 === 'function') {
    await nuxt_plugin_pluginrouting_43fc01f8(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_7b04ec77 === 'function') {
    await nuxt_plugin_pluginmain_7b04ec77(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_65968cac === 'function') {
    await nuxt_plugin_workbox_65968cac(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtpluginc462872c_014eb79d === 'function') {
    await nuxt_plugin_nuxtpluginc462872c_014eb79d(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginse2etesting38f658eb_48fd4454 === 'function') {
    await nuxt_plugin_pluginse2etesting38f658eb_48fd4454(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginslogger6bab7958_0887f0e2 === 'function') {
    await nuxt_plugin_pluginslogger6bab7958_0887f0e2(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsssr2cb5d954_5f78cae8 === 'function') {
    await nuxt_plugin_pluginsssr2cb5d954_5f78cae8(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginscontext0b091dd2_21717fe1 === 'function') {
    await nuxt_plugin_pluginscontext0b091dd2_21717fe1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_affixbannerclient_7d0b875d === 'function') {
    await nuxt_plugin_affixbannerclient_7d0b875d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vClickOutsideclient_fa2ecf0a === 'function') {
    await nuxt_plugin_vClickOutsideclient_fa2ecf0a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_linkhandler_beb21142 === 'function') {
    await nuxt_plugin_linkhandler_beb21142(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_1a0c1998 === 'function') {
    await nuxt_plugin_veevalidate_1a0c1998(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_datadogclient_20227ffa === 'function') {
    await nuxt_plugin_datadogclient_20227ffa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bloomreachtrackingclient_6dd71088 === 'function') {
    await nuxt_plugin_bloomreachtrackingclient_6dd71088(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_trustedshopsclient_40deca0c === 'function') {
    await nuxt_plugin_trustedshopsclient_40deca0c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_promptwatchclient_4df5cc53 === 'function') {
    await nuxt_plugin_promptwatchclient_4df5cc53(app.context, inject)
  }

  if (typeof nuxt_plugin_overrideI18nsetLocale_c41bb4ca === 'function') {
    await nuxt_plugin_overrideI18nsetLocale_c41bb4ca(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_paypalsdkclient_a888a698 === 'function') {
    await nuxt_plugin_paypalsdkclient_a888a698(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlePublisherTags_08b8f4f1 === 'function') {
    await nuxt_plugin_googlePublisherTags_08b8f4f1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_etrustedclient_56d2ae46 === 'function') {
    await nuxt_plugin_etrustedclient_56d2ae46(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_algolialoggerserver_1f245e9e === 'function') {
    await nuxt_plugin_algolialoggerserver_1f245e9e(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_5f3262f2 === 'function') {
    await nuxt_plugin_meta_5f3262f2(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
